<template>
  <div class="addOccupy">
    <el-form ref="form" :model="form" :rules="rules" label-width="96px" label-position="left">
      <el-form-item label="费用" prop="fee">
        <el-input v-model="form.fee" maxlength="15" placeholder="请输入费用"
                  v-input-filter="{ min: 0.01, max: 999, precision: 2 }"/>
      </el-form-item>
      <el-form-item label-width="0px">
        <div class="util-remark">
          注意：修改安检费用不影响历史数据
        </div>
      </el-form-item>
      <el-form-item label-width="0">
        <div class="main-form-btn">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="actionFn" :loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "setFee",
  props: {},
  data() {
    return {
      form: {
        fee: "",
      },
      rules: {
        fee: [
          {required: true, message: "请输入费用", trigger: "blur"},
        ],
      },
      loading: false
    }
  },
  created() {
    this.getInitFn()
  },
  methods: {
    async getInitFn() {
      const url = '/api/v1/manage/inspect/config'
      const {code, data} = await this.$axios.get(url)
      if (code === 1) {
        this.$set(this.form, 'fee', data || '')
      }
    },
    async actionFn() {
      const valid = await this.$refs.form.validate().catch(err => err);
      if (typeof valid === 'boolean' && valid) {
        this.loading = true
        let url = '/api/v1/manage/inspect/config'
        let {code} = await this.$axios.post(url, {
          ...this.form,
        })
        this.loading = false
        if (code === 1) {
          this.$message.success('操作成功')
          this.form = {
            fee: "",
          }
          this.$emit("handClose")
        }
      }
    }

  }
}
</script>

<style scoped>

</style>